module.exports = __webpack_public_path__ + "img/Text.f5bdf630.svg";